<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Any clarifications contact Divya

Vue2File : wwwroot\js\components\MegaMenu\MenuPreOwnedSpecials\MenuPreOwnedSpecials.vue
-->

<template>
  <div class="m-pre-owned-container p-3 p-md-4">
    <h3 class="text-center mb-4 text-capitalize">{{ specialsHeading }}</h3>
    <div v-if="FilteredVehicles && FilteredVehicles.length" class="container-fluid">
      <div class="row">
        <div v-for="(vehicle, index) in FilteredVehicles" :key="index" class="vehicle-box-container col-6 col-md-4 col-xl-3">
          <div class="h-100 vehicle-box p-3">
            <div class="m-pre-owned-title text-center font-weight-bold _theme_font_bold pb-2">
              {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.trim }}
            </div>
            <div class="ft-10 d-flex align-items-center justify-content-center m-pre-owned-img-wrapper">
              <img
                :src="vehicle.firstPhotoUrl"
                :alt="`${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim}`"
                class="img-fluid"
              />
            </div>
            <div class="text-center m-pre-owned-cta">
              <div v-if="(showPayment || priceTypeSelection) && vehicle.preOwnedPaymentTerm" class="ft-12">
                Finance starting at ${{ thousandSeparator(vehicle.financeLowestPayment)}}/mo
                for {{ vehicle.preOwnedPaymentTerm }} months
              </div>
              <div v-else>
                <div v-if="vehicle.sellingPrice" class="font-weight-bold _theme_font_bold">
                  ${{ thousandSeparator(vehicle.sellingPrice) }}
                </div>
                <div v-else class="ft-12 text-uppercase"><strong>Call For Price</strong></div>
              </div>

              <a :href="frameVdpUrl(vehicle)" class="mt-1 mt-xl-2 no-hover px-3 py-2 bgcolor-primary text-white d-inline-block">View Details</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PreownedRotationalSpecials from './MenuPreOwnedSpecials';
export default {
  //need to convert

  mixins: [PreownedRotationalSpecials],
  props:{
    specialsHeading: {
      required: false,
      default: "featured pre-owned",
      type: String
    },
    priceTypeSelection:{
      required: false,
      type: Number,
      default: null
    }
  }
}
</script>
<style scoped>
.m-pre-owned-container {
  border-radius: 25px;
  background-color: #F3F3F3;
  overflow: scroll;
}
.vehicle-box-container {
  padding: 6px;
  height: 200px;
}
.vehicle-box {
  transition: all 0.5s ease;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.m-pre-owned-title {
  font-size: 12px;
}
.m-pre-owned-cta a {
  border-radius: 4px;
}
.m-pre-owned-img-wrapper {
  height: 100px;
  transition: all 0.5s ease;
}
.m-pre-owned-img-wrapper img{
  max-height: 100%;
  border-radius: 10px;
}

.vehicle-box-container:hover .m-pre-owned-img-wrapper {
  transform: translateY(-50%);
  opacity: 0;
  position: absolute;
}
.m-pre-owned-cta {
  font-size: 12px;
  opacity: 0;
  display: none;
  transition: all 0.5s ease;
  transform: translateY(100%);
}
.vehicle-box-container:hover .m-pre-owned-cta {
  opacity: 1;
  display: block;
  transform: translateY(0%);
}
@media(min-width: 1400px) {
  .m-pre-owned-cta {
    font-size: 14px;
  }
  .m-pre-owned-title {
    font-size: 14px;
  }
  .vehicle-box-container {
    height: 250px;
  }
  .m-pre-owned-img-wrapper {
    height: 150px;
  }
}
@media (min-width: 1200px) and (max-width: 1800px) {
  .vm-menu-container .vehicle-box-container {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
}
@media(min-width: 1920px) {
  .m-pre-owned-cta {
    font-size: 16px;
  }
  .m-pre-owned-title {
    font-size: 16px;
  }
}
</style>
